<script>
export default {
  props: {
    showAlert: {
      type: Boolean,
      default: false
    },
    alertType: {
      type: String,
      default: 'success',
      validator: value => {
        return ['success', 'warning', 'error', 'info'].indexOf(value) !== -1
      }
    }
  }
}
</script>
<template>
  <v-alert
    border="top"
    :type="alertType"
    :value="showAlert"
    class="mb-8 py-3"
    dense
    transition="fade-transition">
    <slot></slot>
  </v-alert>
</template>
